import CheckIcon from '@/components/assets/icons/CheckIcon.svg';
import MinusIcon from '@/components/assets/icons/MinusIcon.svg';
import { Grey, White } from '@/styles/Colors';
import styled from '@emotion/styled';

import { FontSize, FontWeight } from '../../styles/Typography';

const StyledCheckbox = styled.span`
  display: inline-flex;
  height: 1.25rem;
  align-items: center;
  gap: 0.5rem;
  > input {
    /* Visually hidden, NOT hidden from the keyboard (ISSUE-065).
       This was 'visibility: hidden', which removes the input from the focus
       order AND the accessibility tree -- so there was no keyboard path to the
       control at all and getByRole('checkbox') could not address it (SC 2.1.1,
       Level A). The label is the visible control; the input still has to be
       the focusable one, because it is what carries the checkbox role and
       state. The clip-rect idiom keeps it zero-area and off-screen while
       leaving it focusable. */
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  > input ~ label {
    cursor: pointer;
    display: inline-block;
    box-sizing: border-box;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 2px;
    border: 2px solid ${(props) => props.color || White};
  }
  > input:checked ~ label {
    background: url(${CheckIcon}) no-repeat;
    background-color: ${(props) => props.color || White};
  }
  > input:disabled {
    border-color: ${Grey[200]};
  }
  > input:disabled ~ label {
    background: url(${MinusIcon}) no-repeat;
    background-color: ${(props) => props.color || Grey[200]};
    cursor: default;
  }
  .checkbox-caption {
    font-size: ${FontSize['Md']};
    font-weight: ${FontWeight['SemiBold']};
    line-height: 150%;
  }
`;
export default StyledCheckbox;
